// import Vue from 'vue'
// import App from './App.vue'
import ComparateurPreview from './components/features/comparateur/ComparateurPreview'

Vue.prototype.$appName = 'cpVm';

global.cpVm = new Vue({
  el: '#comparateur_preview',
  render: h => h(ComparateurPreview),
});
